import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import pure from 'recompose/pure';
import axios from 'axios';
import {RESOURCES as locationResources} from '../fuseLocationsResourceMap';
import {getGetHeaders} from '../shared/functions';
import TextField from 'material-ui/TextField';

/**
 * A function that displays fields with District or Location data.
 *
 * @param record
 * @param styles
 * @return {*}
 * @constructor
 */
class POSUserDistrictLocationTextField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            districtName: null,
        };
    }

    componentWillMount() {
        const record = this.props.record;
        if (record && record.district_id) {
            this.fetchDistrictData(record.district_id);
        }
    }

    componentDidUpdate(prevProps) {
        const districtId = this.props.record.district_id;
        if (districtId && prevProps.record.district_id !== districtId) {
            this.fetchDistrictData(districtId);
        }
    }

    fetchDistrictData = (districtId) => {
        const params = {
            id: districtId
        };
        const resource = locationResources.Districts.GET_ONE(params);
        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            const payload = (result.data && result.data.payload) ? result.data.payload : null;
            if (payload && payload.length) {
                const district = payload[0];
                this.setState({
                    districtName: district.name
                });
            }
        }).catch((error) => {
            if (error.response) {
                // Server response outside 2xx
                console.log(error.response.data);
            } else if (error.request) {
                // No response
                console.log(error.request);
            } else {
                console.log('Error', error.message);
            }
        });
    };

    //
    //

    render() {
        const {
            record,
            styles
        } = this.props;

        const {
            districtName
        } = this.state;

        const userLevel = (record && record.level) ? record.level.toString() : undefined;

        // Super Users have no District or Location (Component displays nothing)
        if (!record.level || userLevel === '4') {
            return null;
        }

        // Display Location Field by default
        let idSource = 'location_id';
        let idLabel = 'Location ID';
        let nameLabel = 'District Name';

        // Display District Field
        if (userLevel === '3') {
            idSource = 'district_id';
            idLabel = 'District ID';
        }

        const fieldStyle = {color: 'rgba(33,33,33)'};

        return (
            <Fragment>
                {record[idSource] && idLabel &&
                <TextField
                    floatingLabelText={idLabel}
                    defaultValue={record[idSource.toString()]}
                    disabled={true}
                    underlineShow={false}
                    style={styles}
                    inputStyle={fieldStyle}
                />
                }
                {districtName &&
                <TextField
                    floatingLabelText={nameLabel}
                    defaultValue={districtName}
                    disabled={true}
                    underlineShow={false}
                    style={styles}
                    inputStyle={fieldStyle}
                />
                }
            </Fragment>
        );
    }
}

POSUserDistrictLocationTextField.propTypes = {
    addLabel: PropTypes.bool,
    record: PropTypes.object,
    styles: PropTypes.object
};

const PurePOSUserDistrictLocationTextField = pure(POSUserDistrictLocationTextField);

PurePOSUserDistrictLocationTextField.defaultProps = {
    addLabel: false,
    styles: {}
};

export default PurePOSUserDistrictLocationTextField;



// WEBPACK FOOTER //
// ./src/Fuse/components/POSUserDistrictLocationTextField.js